import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HttpService } from '../http.service';
import * as Constants from '@emi/shared/constants';
import { SkusLastUpdatedDto } from '@emi/shared/models';
import { tap } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class SkuMetadataService {
    private readonly imageSasKey: string = 'ImageSasKey';
    private readonly imageSasExpiryMinutes: number = 60;

    constructor(private httpService: HttpService) {}

    public getLastUpdated(): Observable<SkusLastUpdatedDto> {
        return this.httpService.getHttp<SkusLastUpdatedDto>(Constants.ServiceConstants.SKUS_LAST_UPDATED);
    }

    public getImageSas(): Observable<string> {
        const cached = sessionStorage.getItem(this.imageSasKey);

        if (cached) {
            const cache = JSON.parse(cached);
            const expiresIn = this.imageSasExpiryMinutes * 60 * 1000; // 60 minutes in ms
            const now = Date.now();

            if (cache.data && now - cache.storedAt < expiresIn) {
                return of(cache.data as string);
            } else {
                sessionStorage.removeItem(this.imageSasKey);
            }
        }

        return this.httpService.getHttpText(Constants.ServiceConstants.METADATA_IMAGE_SAS).pipe(
            tap((response: string) => {
                const valueToStore = { data: response, storedAt: Date.now() };
                sessionStorage.setItem(this.imageSasKey, JSON.stringify(valueToStore));
            })
        );
    }
}
